import { render, staticRenderFns } from "./InsuranceSplitDetailManage.vue?vue&type=template&id=4de2ffcc&scoped=true"
import script from "./InsuranceSplitDetailManage.vue?vue&type=script&lang=js"
export * from "./InsuranceSplitDetailManage.vue?vue&type=script&lang=js"
import style0 from "./InsuranceSplitDetailManage.vue?vue&type=style&index=0&id=4de2ffcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de2ffcc",
  null
  
)

export default component.exports